import theme from '@/config/theme';
import styled from 'vue-styled-components';

export const Wrapper = styled.ul`
  --primary: #23adad;
  --greyLight: #23adade1;
  --greyLight-2: #cbe0dd;
  --greyDark: #2d4848;

  display: flex;
  justify-content: center;
  align-items: center;
  height: 3rem;
  border-radius: 0.6rem;
  background: #ffffff;
  box-shadow: 0 0.8rem 2rem rgba(#5a6181, 0.05);
  list-style-type: none;

  .number,
  .dots,
  .btn {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0.2rem;
    font-size: inherit;
    cursor: pointer;
    user-select: none;
    font-weight: bold;
  }

  .dots {
    width: 1.6rem;
    height: 1.6rem;
    color: var(--greyLight);
    cursor: initial;
  }

  .number {
    width: 1.6rem;
    height: 1.6rem;
    border-radius: 0.4rem;

    &:hover {
      color: #fff;
      background-color: ${theme.colors.primaryBlue};
    }

    &.active {
      color: #ffffff;
      background: ${theme.colors.primaryBlue};
      font-weight: 600;
      border: 1px solid ${theme.colors.primaryBlue};
    }
  }

  & .btn {
    color: var(--greyLight);
    transform: scale(1);

    &.active {
      color: var(--greyDark);
      pointer-events: initial;

      &:hover {
        color: var(--primary);
      }
    }

    &:hover {
      cursor: pointer;
      transform: scale(1.2);
    }

    &.disabled {
      pointer-events: none;
      cursor: default;
      opacity: 0.5;
    }
  }
`;
